import React, { useState, useEffect } from "react";

import { selectDateOrTime } from "../../../../../services/saleAnalysis-services";
import {
  Button,
  Chip,
  colors,
  Container,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";

import { uri } from "../../../../../help/Api";
import TotalCard from "../../../../../components/TotalCard";
import { useHistory } from "react-router-dom";
import {
  useStylesHed,
  useStylesSpDial,
  useStylesUiElemment,
} from "../../../../../St/comps/UseStyle";
import { insh as inshst } from "../../../../../Context/InshSt";
import ScannerIcon from "@material-ui/icons/Scanner";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import { sto } from "../../../../../Context/InshData";
import axios from "axios";
import SadadInvoicesForm from "./SadadInvoicesForm";
import SadadInvoicesTable from "./SadadInvoicesTable";
import DailyReportFilter from "../EveryDay/DailyReportFilter";
import InvSearchPrint from "../../../../../Reviews/Sales/InvsSearch/InvSearchPrint";
const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
  },
  itemW: {
    // display:'flex',
    width: "90%",
  },
  headerTitle: {
    backgroundColor: colors.green[50],
    textAlign: "center",
    fontSize: 20,
    width: "100%",
  },

  allWidth: {
    minWidth: 650,
  },
  checStyl: {
    marginTop: "17px",
    fontSize: "16px",
    padding: "-1px",
  },
  purchTotalCard: {
    backgroundColor: colors.blue[50],
    borderColor: colors.blue[300],
  },
}));

export default function SadadInvoices(props) {
  const { AutoOptions, CustomerOptions, isPurches } = props;

  let idBranch = AutoOptions?.Branches[0]?.id;
  let nameBranch = AutoOptions?.Branches[0]?.name;

  let iduser = AutoOptions.Users[0].id;
  let nameuser = AutoOptions.Users[0].name;

  const [constCenters, setConstCenters] = useState(() => {
    return [{ id: -1, name: "الكل" }, ...AutoOptions.center];
  });
  const [customers, setCustomers] = useState(() => {
    return [{ id: -1, name: "الكل" }, ...CustomerOptions];
  });


  const SalesDetailsDefouls = {
    //selectType: selectTypes[0],
    proctype: isPurches ? "01" : "02",
    // inv_type:-1,
    pay_type: -1,
    timeF: moment(new Date()).startOf("day").format("HH:mm"),
    timeT: moment(new Date()).endOf("day").format("HH:mm"),
    dateFrom: moment(new Date()).format('YYYY-MM-DD'),
    timeFrom: moment(new Date()).format('HH:mm'),
    dateTo: moment(new Date()).format('YYYY-MM-DD'),
    timeTo: moment(new Date()).format('HH:mm'),
    selectTime: selectDateOrTime[0],
    cust: CustomerOptions[0],
    inv_type: AutoOptions.types[0],
    system: "sale",
    center: constCenters[0],
    user: { id: sto.User_typei == 1 ? -1 : iduser, name: sto.User_typei == 1 ? "الكل" : nameuser },
    branch: { id: sto.User_typei == 1 ? -1 : idBranch, name: sto.User_typei == 1 ? "الكل" : nameBranch },
    selectTime: selectDateOrTime[0],

  };

  const [rptParams, setRptParams] = React.useState(SalesDetailsDefouls);
  const classes = useStyles();
  const clasui = useStylesUiElemment();
  const clasSp = useStylesSpDial();
  const { t } = useTranslation(["forms", "translation"]);

  const [data, setData] = useState([]);
  const [dataSadad, setDataSdada] = useState([]);

  const [fetching, setFetching] = useState(false);
  const viewHandle = async () => {
    setData([]);
    setDataSdada([]);

    setFetching(true);
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `RptSales/ReportSadad?proctype=${rptParams.proctype}
        &&branch=${rptParams.branch.id}
        &&FDate=${rptParams.dateFrom + ' ' + rptParams.timeFrom}
        &&TDate=${rptParams.dateTo + ' ' + rptParams.timeTo}
       &&inv_type=${rptParams.inv_type?.id}
       &&pay_type=${rptParams?.pay_type}
       &&cust_id=${rptParams.cust.id}
       &&center=${rptParams?.center?.id}
       &&user=${rptParams?.user.id}
       &&date_time=${rptParams.selectTime.name}`
    } else {
      Urls = `RptSales/ReportSadad?proctype=${rptParams.proctype}
        &&branch=${rptParams.branch.id}
        &&FDate=${rptParams.dateFrom + ' ' + rptParams.timeFrom}
        &&TDate=${rptParams.dateTo + ' ' + rptParams.timeTo}
       &&inv_type=${rptParams.inv_type?.id}
       &&pay_type=${rptParams?.pay_type}
       &&cust_id=${rptParams.cust.id}
       &&center=${rptParams?.center?.id}
       &&user=${rptParams?.user.id}
       &&date_time=${rptParams.selectTime.name}&&db_name=${sto?.db_name}`
    }
    await axios
      .get(
        uri + Urls
      )
      .then((res) => {
        setData(res.data);
        const data2 = res.data.salesSadad.map((row, i) => {
          return {
            ...row,
            status: row.AllocatedPayment == row.netAmount ? "تم السداد" : row.AllocatedPayment < row.netAmount && row.AllocatedPayment > 0 ? "سداد جزء" : "لم يتم",
            invKind: row.inv_type == 1 ? "اجل" : "نقدي",
            paid: (parseFloat(row.cash_part) + parseFloat(row.network_part) + parseFloat(row.bank_part))?.toFixed(2),
          };
        });
        setDataSdada(data2);
        console.log(" the data is", res.data);
        setFetching(false);
      })
      .catch((err) => {
        setFetching(false);
        console.log(err);
        // toast.err("يوجد خطأ في الجلب");
        setDataSdada([]);
        setData([]);
      });
  };
  const his = useHistory();
  const [dataPrint, setDataPrint] = useState({});
  const [infoPrint, setInfoPrint] = useState(false);
  const closePrint = (type) => {
    setDataPrint({});
    setInfoPrint(false);
  };


  const printHandle = () => {
    if (data.lenght == 0) {
      alert(t("no-data"));
    } else {
      const info = {
        data: dataSadad,
        tot: data?.totals,
        title: isPurches ? "تقرير حركة سداد المشتريات  " : "تقرير حركة سداد فواتير المبيعات",
        auto: {},
        fDate: rptParams.dateFrom,
        tDate: rptParams.dateTo,
        ElmntShow: true,
        printKind: 2,
        branch: rptParams.branch?.name,
        cust: rptParams?.cust?.name,
        username: rptParams?.user?.name,
        //totsp:rpt.totSelcPeriod,balncsp:rpt.balncSelcPeriod
      };
      setDataPrint(info);
      setInfoPrint(true);
      // localStorage.setItem("iInfos", JSON.stringify(info));
      // his.push({ pathname: "/invSearch" });
      // window.location.reload(true);
    }
  };
  let excel_name = "SadadMovementReport";

  const excelHeaders = [
    { label: "رقم الفاتورة", key: "id" },
    { label: "تاريخ الفاتورة", key: "date" },
    { label: "الوقت", key: "time" },
    { label: "توع الفاتورة", key: "invKind" },
    { label: isPurches ? "المورد" : "العميل", key: "cust_name" },
    { label: "مبلغ الفاتورة", key: "netAmount" },
    { label: "المدفوع", key: "paid" },
    { label: "المتبقي", key: "agel_part" },
    { label: "السداد", key: "AllocatedPayment" },
    { label: "حالة السداد", key: "status" },

  ];

  const onChangeData = (propName) => (event) => {
    setRptParams({ ...rptParams, [propName]: event.target.value });
  };
  const onChangeAutoData = (propName, newValue) => {
    setRptParams({ ...rptParams, [propName]: newValue });
  };
  return (
    <div className={classes.root}>
      <Grid container item xs={12}>
        <Typography
          size="small"
          className={classes.headerTitle}
          style={{
            backgroundColor: isPurches ? colors.blue[50] : colors.green[50], fontWeight: "bold",
          }}
          color="primary"
        >
          {isPurches ? t("purchase-invoices-payment-report") : t("sales-invoices-payment-report")}
        </Typography>
      </Grid>
      <Typography
        component="div"
        style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
      >
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
            paddingBottom: "0px",
            borderBottomColor: isPurches ? colors.blue[300] : colors.green[300],
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
          }}
        >
          <DailyReportFilter {...{ rptParams, setRptParams, isPurches }} />
          <SadadInvoicesForm
            {...{
              AutoOptions,
              CustomerOptions,
              rptParams,
              onChangeData,
              onChangeAutoData,
              isPurches,
              constCenters,
              customers
            }}
          />
          <Grid
            container
            justifyContent="center"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            spacing={1}
          >
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<ScannerIcon />}
                size="large"
                style={
                  (inshst.sal.iconBtn,
                    { borderRadius: 0 })
                }
                className={isPurches ? [clasui.buttonPurch] : [clasui.buttonSal]}
                onClick={() => viewHandle()}
              >
                {t("forms:view")}
              </Button>
            </Grid>
            <Grid item >
              {data && !fetching && data.salesSadad && (
                <CSVLink
                  separator={";"}
                  filename={excel_name}
                  data={dataSadad}
                  headers={excelHeaders}
                >
                  {" "}
                  <Button
                    disabled={fetching}
                    variant="contained"
                    startIcon={<TableChart />}
                    size="large"
                    color="primary"
                    style={{ borderRadius: 0 }}
                    className={isPurches ? [clasui.buttonPurch] : [clasui.buttonSal]}
                  >
                    {t("excel_export")}{" "}
                  </Button>
                </CSVLink>
              )}
            </Grid>
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<PrintIcon />}
                color="primary"
                size="large"
                className={isPurches ? [clasui.buttonPurch] : [clasui.buttonSal]}
                // className={[clasui.button, clasSp.clSec]}
                style={
                  (inshst.sal.iconBtn,
                    { borderRadius: 0 })
                }
                onClick={printHandle}
              >
                {t("forms:print")}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                startIcon={<KeyboardReturnSharpIcon />}
                color="secondary"
                size="large"
                className={[clasui.button, clasSp.clcan]}
                style={
                  (inshst.sal.iconBtn,
                    { borderRadius: 0 })
                }
                onClick={() => his.goBack()}
              >
                {t("forms:exit")}
              </Button>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth={true} style={{ padding: "4px" }}>
          <Grid container spacing={1} style={{ paddingTop: "10px" }}>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: isPurches ? classes.purchTotalCard : null,
                  title: "عدد السجلات",
                  value: data?.salesSadad?.length.toFixed(2),
                }}
              />
            </Grid>

            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: isPurches ? classes.purchTotalCard : null,
                  title: isPurches ? "إجمالي مشتريات" : "إجمالي مبيعات",
                  value: data?.totals?.netAmount.toFixed(2),
                }}
              />
            </Grid>

            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: isPurches ? classes.purchTotalCard : null,
                  title: "إجمالي المدفوع",
                  value: data?.totals?.paid.toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: isPurches ? classes.purchTotalCard : null,
                  title: "اجمالي المتبقي",
                  value: data?.totals?.agel.toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: isPurches ? classes.purchTotalCard : null,
                  title: "إجمالي السداد",
                  value: data?.totals?.sadad.toFixed(2),
                }}
              />
            </Grid>
          </Grid>
        </Container>
        {/* <br /> */}
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
            marginTop: "0.5rem"
          }}
        >
          <Grid container justifyContent="center">
            <Grid item container justifyContent="center" xs={12}>
              <BeatLoader loading={fetching} color={isPurches ? colors.blue[300] : colors.green[300]} />
              {!fetching && (
                <SadadInvoicesTable
                  {...{
                    data: dataSadad ? dataSadad : [],
                    isPurches,
                  }}
                />
              )}
            </Grid>
          </Grid>
        </Container>
      </Typography>
      {infoPrint ? <InvSearchPrint dataPrint={dataPrint} closePrint={closePrint} infoPrint={infoPrint} /> : null}

    </div>
  );
}
